import React from 'react';
import { Button, Row, Col } from 'reactstrap';

const WelcomeStep = ({ plan, onNext }) => {
  return (
    <div className="onboarding-step welcome-step-fullscreen">
      <Row className="align-items-center min-vh-75">
        <Col lg={6} className="welcome-content">
          <div className="welcome-animation mb-4">
            <i className="mdi mdi-cog-sync-outline onboarding-main-icon"></i>
          </div>
          
          <h1 className="onboarding-main-title mb-2">
            Crea tu sistema de ventas en automático
          </h1>
          
          <h2 className="onboarding-subtitle mb-3">
            Elige qué automatizar. Claryo se encarga del resto.
          </h2>
          
          <p className="onboarding-description mb-4">
            No código. No complejidad.
            <br />
            <strong>Tú diseñas. Claryo ejecuta todos los días.</strong>
          </p>

          <div className="value-proposition-box mb-4">
            <div className="value-box-header">
              <i className="mdi mdi-check-circle text-success"></i>
              <span>Esto no es coaching ni curso</span>
            </div>
            <p className="value-box-text">
              Es el <strong>sistema</strong> que ejecuta por ti mientras trabajas en tu negocio.
            </p>
          </div>

          <Button 
            color="primary" 
            size="lg"
            className="onboarding-primary-btn"
            onClick={onNext}
          >
            Crear mi primer sistema
            <i className="mdi mdi-arrow-right ms-2"></i>
          </Button>
          
          <p className="text-muted mt-3 mb-0" style={{fontSize: '0.85rem'}}>
            Siguiente: Elige tu sistema (30 segundos)
          </p>
        </Col>

        <Col lg={6} className="plan-showcase">
          <div className="plan-card-fullscreen">
            <div className="plan-badge-large">
              <span>Plan Free - Activo</span>
            </div>
            
            <div className="plan-header-large">
              <h3>Tu primer sistema listo para ejecutar</h3>
              <div className="plan-price-large">
                <span className="price-amount">$0</span>
                <span className="price-period">/mes</span>
              </div>
              <p className="plan-subtitle">Sin tarjeta • Sin costo • Cancela cuando quieras</p>
            </div>
            
            <div className="plan-benefits-large">
              <div className="benefit-item-large">
                <div className="benefit-icon">
                  <i className="mdi mdi-automation"></i>
                </div>
                <div className="benefit-content">
                  <h5>Responde leads mientras duermes</h5>
                  <p>Capta y responde leads en automático, sin que tú estés</p>
                </div>
              </div>
              
              <div className="benefit-item-large">
                <div className="benefit-icon">
                  <i className="mdi mdi-calendar-clock"></i>
                </div>
                <div className="benefit-content">
                  <h5>Agenda llamadas en automático</h5>
                  <p>Programa llamadas mientras trabajas en otras cosas</p>
                </div>
              </div>
              
              <div className="benefit-item-large">
                <div className="benefit-icon">
                  <i className="mdi mdi-email-send"></i>
                </div>
                <div className="benefit-content">
                  <h5>Envía seguimiento sin olvidarlo</h5>
                  <p>Nunca más se te olvide hacer seguimiento a un lead</p>
                </div>
              </div>
              
              <div className="benefit-item-large">
                <div className="benefit-icon">
                  <i className="mdi mdi-refresh"></i>
                </div>
                <div className="benefit-content">
                  <h5>Recupera leads que no respondieron</h5>
                  <p>Reactiva conversaciones que se quedaron en el aire</p>
                </div>
              </div>
            </div>

            <div className="plan-note-large">
              <i className="mdi mdi-information-outline"></i>
              <div>
                <strong>Configuras una vez. Claryo ejecuta todos los días.</strong>
                <br />
                <span className="text-muted">
                  Puedes escalar tu plan cuando quieras desde Configuración
                </span>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default WelcomeStep;

